module.exports = __webpack_public_path__ + "static/img/anxunCompang.2379dc53.png";